module.exports = __webpack_public_path__ + "img/about-1.7397b46.jpg";